import { render } from "./Provider.vue?vue&type=template&id=6a8d4d7d&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"

import "./Provider.vue?vue&type=style&index=0&id=6a8d4d7d&lang=scss"
import "./Provider.vue?vue&type=style&index=1&id=6a8d4d7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8d4d7d"]])

export default __exports__